/** Matches Palaute.models.event constants used in automation payloads. */
export const AUTOMATION_EVENT_APPLICATION_STEP_CHANGED = 'application_step_changed';
export const AUTOMATION_EVENT_APPLICATION_OUTCOME_CHANGED = 'application_outcome_changed';
export const AUTOMATION_EVENT_TIME_BASED = 'time_based_event';
